export const buildDisplayPrice = (plan) => {
  const amount = plan?.price?.amount;
  if (!Number.isFinite(amount) || amount < 0) return null;
  return `${amount.toFixed(2).replace('.', ',')} €`;
};
